export interface DocumentosKpis {
  cantidad: number;
  precioTotal: number;
  precioNeto: number;
  pesoTotalKg: number;
  volumenTotalM3: number;
}

export const emptyDocumentosKpis = (): DocumentosKpis => ({
  cantidad: 0,
  precioTotal: 0,
  precioNeto: 0,
  pesoTotalKg: 0,
  volumenTotalM3: 0,
});

const resolveKpiNumber = (data: unknown, camel: string, pascal: string): number => {
  const payload = data as Record<string, unknown> | null | undefined;
  const raw = payload?.[camel] ?? payload?.[pascal];
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isFinite(n) ? n : 0;
};

export const normalizeDocumentosKpis = (data: unknown): DocumentosKpis => ({
  cantidad:
    resolveKpiNumber(data, 'cantidad', 'Cantidad') ||
    resolveKpiNumber(data, 'cantidadPedidos', 'CantidadPedidos'),
  precioTotal: resolveKpiNumber(data, 'precioTotal', 'PrecioTotal'),
  precioNeto: resolveKpiNumber(data, 'precioNeto', 'PrecioNeto'),
  pesoTotalKg: resolveKpiNumber(data, 'pesoTotalKg', 'PesoTotalKg'),
  volumenTotalM3: resolveKpiNumber(data, 'volumenTotalM3', 'VolumenTotalM3'),
});
